import { Tooltip } from 'antd';
import { formatUnitPrice, formatUnitPriceShort } from '@/utils/money';
import { NUMERIC_STYLE } from './numeric';

interface UnitPriceCellProps {
  /** `unit_price` — the price of a full copy, at eight places. */
  unitPrice: string;
  currency: string;
}

/**
 * The price of a full copy, shortened to four places so the column holds its
 * shape, with all eight one hover away. The `<span>` is what `Tooltip` attaches
 * its ref to.
 */
export const UnitPriceCell = ({ unitPrice, currency }: UnitPriceCellProps) => (
  <Tooltip title={formatUnitPrice(unitPrice, currency)}>
    <span style={NUMERIC_STYLE}>
      {formatUnitPriceShort(unitPrice, currency)}
    </span>
  </Tooltip>
);
